import React, { useEffect, useState } from "react";
import axios from "axios";
import PotreePointcloudShared from "components/vr/PotreePointcloudShared";
import LoginPopup from "components/login-popup";

const Shared = () => {
  const query = new URLSearchParams(window.location.search);
  const token = query.get("token");

  const [metadataUrl, setMetadataUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;

    const fetchMetadataUrl = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/projects/shared/${token}`
        );

        const metadataFile = response.data.files.find(file =>
          file.url.endsWith("metadata.json")
        );

        if (metadataFile) {
          setMetadataUrl(metadataFile.url);
        } else {
          setError("Arquivo de metadata não encontrado.");
        }
      } catch (err) {
        console.error("Erro ao buscar metadata:", err);
        setError("Erro ao carregar o metadata.");
      }
    };

    fetchMetadataUrl();
  }, [token]);

  useEffect(() => {
    document.body.style.setProperty("overflow", "hidden", "important");
    return () => {
      document.body.style.setProperty("overflow", "auto", "important");
    };
  }, []);

  useEffect(() => {
    if (metadataUrl) {
      // Adicionar os estilos no head
      const styleElement = document.createElement("style");
      styleElement.textContent = `
        #potree_sidebar_container > div > div.group > div.buttons,
        #potree_sidebar_container > div > div.config > div.QuitButton,
        #potree_sidebar_container > div > div.group > div.showOptions {
          display: none !important;
        }
      `;
      document.head.appendChild(styleElement);

      // Limpar os estilos ao desmontar o componente
      return () => {
        document.head.removeChild(styleElement);
      };
    }
  }, [metadataUrl]);

  if (error) {
    return <p>{error}</p>;
  }

  if (!metadataUrl) {
    return (
      <div className="d-flex justify-content-center mt-60 vh-100 vw-100">
        <div className="spinner-border" role="status">
          <span className="sr-only">Carregando metadata...</span>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        overflow: "hidden",
        zIndex: 1
      }}
    >
      <PotreePointcloudShared metadataUrl={metadataUrl} />
      <LoginPopup isPublic={true} />
    </div>
  );
};

export default Shared;
